<template>
  <v-dialog max-width="1000px" v-model="dialog">
    <v-card>
      <v-card-title class="headline">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="pr-5" large v-on="on"  @click="toPrint()">cloud_download</v-icon>
          </template>
          <span>Descargar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon class="pr-5" large v-on="on"  @click="sendWhatsApp()">send</v-icon>
          </template>
          <span>Enviar por WhatsApp</span>
        </v-tooltip>
      </v-card-title>
      <div id="contenedor">
        <v-card-text v-for="i in imprimir" :key="i._id" style="page-break-before: always;">
          <div class="factura">
            <header style="display: flex">
              <div id="logo" style="flex-grow: 1">
                <img src="../../assets/LasMisionesLogo.png" width="200px" height="100px" />
              </div>
              <!-- <div id="datos" style="flex-grow: 2; text-align:center;">
                <img src="../../assets/espacioRedesLogo.png" width="200px" height="100px" />
              </div> -->
              <div id="fact" style="flex-grow: 2">
                <p>
                  {{ i.tipo_comprobante }}
                  <br />
                  {{ i.serie_comprobante }}-{{ i.num_comprobante }}
                  <br />
                  {{ i.fecha }}
                </p>
              </div>
            </header>
            <br />
            <section>
              <div style="padding-top: 10px;">
                <table id="facliente">
                  <tbody>
                    <tr>
                      <td id="cliente">
                        <strong>Sr(a). {{ i.persona.nombre }}</strong>
                        <br />
                        <strong>Dirección:</strong>
                        <span v-if="i.persona !== undefined">
                          {{ cliente.direccion }}
                        </span>
                        <br />
                        <strong>Teléfono:</strong>
                        <span v-if="i.persona !== undefined">
                          {{ cliente.telefono }}
                        </span>
                        <br />
                        <strong>Email:</strong>
                        <span v-if="i.persona !== undefined">
                          {{ cliente.email }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            <br />
            <section>
              <div>
                <table id="facarticulo" style="width: 100%;">
                  <thead style="background: #2183e3 !important; color:white; padding-top: 5px !important; padding-bottom:5px !important">
                    <tr id="fa" style="background: #2183e3 !important;">
                      <th>CANT</th>
                      <th>UNIDAD</th>
                      <th>ARTICULO</th>
                      <th>PRECIO UNIT</th>
                      <th>PRECIO TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="det in i.detalles" :key="det._id">
                      <td style="text-align:center !important;">{{ det.cantidad }}</td>
                      <td style="text-align:center !important;">{{ det.unidad }}</td>
                      <td style="text-align:center !important;">{{ det.articulo }}</td>
                      <td style="text-align:center !important;">$ {{ det.precio }}</td>
                      <td style="text-align:right; padding-top10px !important">
                        $ {{ det.cantidad * det.precio }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th style="text-align:right;">TOTAL</th>
                      <th style="text-align:right;">$ {{ i.total }}</th>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </section>
            <br />
            <br />
            <footer>
              <div id="gracias">
                <p>
                  <b>Gracias por su compra!</b>
                </p>
              </div>
            </footer>
          </div>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-btn @click="ocultarComprobante()" color="blue darken-1" text
          >Cancelar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      detalles_existe: false,
      total: 0,
      totalImpuesto: 0,
      impuesto: 0,
      dialog: false,
    };
  },
  props: ["imprimir"],
  created() {
    let me = this;
    this.imprimir.forEach((i) => {
      // debugger
      me.detalles_existe = i.detalles === undefined ? false : true;
    });
  },
  computed: {
    ...mapState("clienteNamespace", ["cliente"]),
    ...mapState("usuarioNamespace", ["token"]),
  },
  methods: {
    ...mapActions("clienteNamespace", ["getCliente"]),
    ocultarComprobante() {
      this.dialog = false;
    },
    calcularTotal() {},
    async llamarCliente() {
      this.imprimir.forEach((element) => {
        let data_persona = {
          persona: element.persona,
          token: this.token,
        };

        this.getCliente(data_persona);
      });
    },
    toPrint(){
      this.$htmlToPaper('contenedor')
    },
    sendWhatsApp(){
      this.$htmlToPaper('contenedor', null, () => {
        if (sessionStorage.desktop) {
          let test = "Prueba mensaje";
          window.open(`https://api.whatsapp.com/send`);
        } else if (localStorage.mobile) {
          let test2 = "Prueba mensaje";
          window.open(`whatsapp://send?phone=Desde app ${test2}`);
        }
      });
    }
  },
};
</script>
<style>
#factura {
  padding: 20px;
  font-family: Arial, sans-serif;
  font-size: 16px;
}

#logo {
  float: left;
  margin-left: 2%;
  margin-right: 2%;
}
#imagen {
  width: 100px;
}

#fact {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}

#datos {
  float: left;
  margin-top: 0%;
  margin-left: 2%;
  padding-top: 20px;
  margin-right: 2%;
  /*text-align: justify;*/
}

#encabezado {
  text-align: center;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 16px;
}

section {
  clear: left;
}

#cliente {
  text-align: left;
}

#facliente {
  width: 40%;
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 15px;
}

#fa {
  color: #ffffff;
  font-size: 14px;
}

#facarticulo {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  padding: 20px;
  margin-bottom: 15px;
}

#facarticulo thead {
  padding: 20px !important;
  background: #2183e3;
  text-align: center;
  border-bottom: 1px solid #ffffff;
}

#gracias {
  text-align: center;
}
</style>
